if (!window.Maximize?.loadedScript?.includes("store-locator.js")) {
  if (window.Maximize?.loadedScript) {
    window.Maximize.loadedScript.push("store-locator.js");
  }

  const GEO_SESSION_KEY = "a2z_store_locator_geo_prompted";

  // Canadian postal codes (A1A 1A1) and US ZIP codes (12345 / 12345-6789).
  const POSTAL_PATTERN = /^(?:[A-Z]\d[A-Z]\d[A-Z]\d|\d{5}(?:-?\d{4})?)$/;

  let storeLocatorRegistered = false;

  function getStoreLocatorRoot() {
    return document.querySelector(".store-locator-popup__container");
  }

  function readJsonScript(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error("[store-locator] failed to parse", id, err);
      return null;
    }
  }

  function registerStoreLocator() {
    if (storeLocatorRegistered || !window.Alpine) return;
    storeLocatorRegistered = true;

    Alpine.data("xStoreLocator", () => ({
      show: false,
      active: null,
      currentSelected: false,
      selectedStore: "",
      postalInput: "",
      postalError: false,
      postalFallback: false,
      geoLoading: false,
      geoError: false,
      geoResultOpen: false,
      geoResultStoreName: "",
      filterMarketHandle: null,
      pendingPostal: null,
      closestBlockId: null,
      visibleStoreIds: null,
      postalMap: {},
      marketsByHandle: {},
      stores: [],
      sectionId: "",
      _postalLoadPromise: null,

      init() {
        const root = this.$el;
        this.sectionId = root.dataset.sectionId || "";
        this.active = root.dataset.activeBlockId || null;
        const autoSelectFirstStore = root.dataset.autoSelectFirst === "true";

        const stores = readJsonScript(`StoreLocatorStores-${this.sectionId}`);
        this.stores = Array.isArray(stores) ? stores : [];

        console.log("[store-locator] init", {
          sectionId: this.sectionId,
          stores: this.stores,
          autoSelectFirstStore,
        });

        const saved = JSON.parse(localStorage.getItem("currentStoreSelected") || "null");
        const currentSelectedStore = saved?.currentSelected
          ? saved.currentSelected
          : autoSelectFirstStore
            ? this.active
            : false;
        const currentCheckbox = document.getElementById(
          `Checkbox__${this.sectionId}-${currentSelectedStore}`
        );
        if (currentCheckbox) {
          this.currentSelected = currentSelectedStore;
          this.selectedStore = currentCheckbox.dataset.storeName;
          Alpine.store("xStoreMap").currentStoreSelected = this.selectedStore;
          const postal = saved?.postal || "";
          if (postal) {
            this.pendingPostal = this.normalizePostal(postal);
            Alpine.store("xStoreMap").currentPostal = this.formatPostalDisplay(postal);
          }
          localStorage.setItem(
            "currentStoreSelected",
            JSON.stringify({
              selectedStore: this.selectedStore,
              currentSelected: this.currentSelected,
              postal: this.pendingPostal || saved?.postal || "",
            })
          );
          document.dispatchEvent(
            new CustomEvent("maximize:store-changed", { detail: { store: this.selectedStore } })
          );
        } else if (saved?.postal) {
          this.pendingPostal = this.normalizePostal(saved.postal);
          Alpine.store("xStoreMap").currentPostal = this.formatPostalDisplay(saved.postal);
        }

        this.loadPostalData();

        const storeLocatorContentEl = this.$el.querySelector(".store-locator__content");
        const tabletMediaQuery = window.matchMedia(`(min-width: ${MIN_DEVICE_WIDTH.tablet}px)`);

        const handleMediaChange = (e) => {
          if (!storeLocatorContentEl || !this.show) return;
          if (e.matches) {
            storeLocatorContentEl.style.height = `${storeLocatorContentEl.getBoundingClientRect().height}px`;
          } else {
            storeLocatorContentEl.style.height = "";
          }
        };

        if (storeLocatorContentEl) {
          tabletMediaQuery.addEventListener("change", handleMediaChange);
        }

        document.addEventListener(`${STORE_MAP_EVENT.openPopup}`, () => {
          this.openStoreLocatorPopup();
          setTimeout(() => handleMediaChange(tabletMediaQuery), 300);
        });

        if (window.Shopify?.designMode) {
          document.addEventListener("shopify:section:select", (event) => {
            if (event.target.classList.contains("section-store-locator")) {
              this.openStoreLocatorPopup();
            }
          });
        }
      },

      normalizePostal(postal) {
        return String(postal || "")
          .toUpperCase()
          .replace(/\s+/g, "");
      },

      formatPostalDisplay(postal) {
        const n = this.normalizePostal(postal);
        if (n.length === 6) return `${n.slice(0, 3)} ${n.slice(3)}`;
        return n;
      },

      isPostalLike(postal) {
        return POSTAL_PATTERN.test(this.normalizePostal(postal));
      },

      /** Market used for any postal code missing from a2z-postal-markets.json. */
      fallbackMarketHandle() {
        return window.Maximize?.catalog?.fallbackMarketHandle || null;
      },

      normalizeMatch(value) {
        return String(value || "")
          .toLowerCase()
          .replace(/&amp;/g, "&")
          .replace(/&#39;/g, "'")
          .replace(/&quot;/g, '"')
          .replace(/[^a-z0-9]+/g, " ")
          .trim();
      },

      marketTokens(handle) {
        const market = this.marketsByHandle[handle];
        const name = this.normalizeMatch(market?.name);
        const normalizedHandle = this.normalizeMatch(market?.handle || handle);
        return [name, normalizedHandle, ...(normalizedHandle ? normalizedHandle.split(" ") : [])].filter(
          (t) => t && t.length > 2 && !["location", "region", "pos"].includes(t)
        );
      },

      storeMatchesMarket(storeName, marketHandle) {
        if (!marketHandle) return true;
        const s = this.normalizeMatch(storeName);
        if (!s) return false;
        return this.marketTokens(marketHandle).some((token) => s === token || s.includes(token));
      },

      isStoreVisible(blockId) {
        if (!this.filterMarketHandle || !this.visibleStoreIds) return true;
        return this.visibleStoreIds.includes(blockId);
      },

      loadPostalData() {
        if (this._postalLoadPromise) return this._postalLoadPromise;

        const postalUrl = window.Maximize?.postalMarketsUrl;
        const marketsUrl = window.Maximize?.catalog?.marketsUrl;

        this._postalLoadPromise = (async () => {
          try {
            const fetches = [
              postalUrl ? fetch(postalUrl).then((r) => (r.ok ? r.json() : null)) : Promise.resolve(null),
              marketsUrl
                ? fetch(marketsUrl).then((r) => (r.ok ? r.json() : { markets: [] }))
                : Promise.resolve({ markets: [] }),
            ];
            const [postalMap, marketsPayload] = await Promise.all(fetches);
            if (postalMap && typeof postalMap === "object") this.postalMap = postalMap;
            const byHandle = {};
            (marketsPayload?.markets || []).forEach((m) => {
              if (m?.handle && m.type === "LOCATION") {
                const lat = Number(m.lat);
                const lng = Number(m.lng);
                byHandle[m.handle] = {
                  name: m.name,
                  handle: m.handle,
                  lat: Number.isFinite(lat) ? lat : null,
                  lng: Number.isFinite(lng) ? lng : null,
                };
              }
            });
            this.marketsByHandle = byHandle;
            console.log("[store-locator] fetched postal/markets", {
              postalMap: this.postalMap,
              marketsByHandle: this.marketsByHandle,
            });
          } catch (err) {
            console.error("[store-locator] postal map load failed", err);
          }
          return this.postalMap;
        })();

        return this._postalLoadPromise;
      },

      selectClosestStore(marketHandle) {
        const matching = this.stores.filter((store) => this.storeMatchesMarket(store.name, marketHandle));
        console.log("[store-locator] selectClosestStore", {
          marketHandle,
          stores: this.stores,
          tokens: this.marketTokens(marketHandle),
          matching,
        });

        this.visibleStoreIds = matching.map((store) => store.id);
        this.currentSelected = false;
        this.selectedStore = "";
        this.closestBlockId = null;

        if (!matching.length) {
          console.warn("[store-locator] no store matched market", marketHandle);
          return false;
        }

        const best = matching[0];
        this.currentSelected = best.id;
        this.selectedStore = best.name;
        this.active = best.id;
        this.closestBlockId = best.id;
        console.log("[store-locator] auto-selected store", best);
        return true;
      },

      async applyPostalFilter() {
        console.log("[store-locator] applyPostalFilter start", {
          postalInput: this.postalInput,
          postalMapKeys: Object.keys(this.postalMap || {}),
        });

        await this.loadPostalData();

        const key = this.normalizePostal(this.postalInput);

        if (!this.isPostalLike(key)) {
          this.postalError = true;
          this.postalFallback = false;
          console.warn("[store-locator] invalid postal", key);
          return;
        }

        const mapped = this.postalMap?.[key];
        const handle = mapped || this.fallbackMarketHandle();
        console.log("[store-locator] applyPostalFilter lookup", { key, mapped, handle });

        if (!handle) {
          this.postalError = true;
          this.postalFallback = false;
          console.warn("[store-locator] unmapped postal and no fallback market", key);
          return;
        }

        this.postalError = false;
        this.postalFallback = !mapped;
        this.filterMarketHandle = handle;
        this.pendingPostal = key;
        this.selectClosestStore(handle);
      },

      clearPostalFilter() {
        this.postalInput = "";
        this.postalError = false;
        this.postalFallback = false;
        this.geoError = false;
        this.filterMarketHandle = null;
        this.pendingPostal = null;
        this.closestBlockId = null;
        this.visibleStoreIds = null;
      },

      haversineKm(lat1, lng1, lat2, lng2) {
        const toRad = (deg) => (deg * Math.PI) / 180;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
        return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      },

      formatGeoError(err) {
        if (!err) return { message: "unknown error" };
        const codeMap = {
          1: "PERMISSION_DENIED",
          2: "POSITION_UNAVAILABLE",
          3: "TIMEOUT",
        };
        return {
          name: err.name || "GeolocationError",
          message: err.message || String(err),
          code: err.code,
          codeLabel: err.code != null ? codeMap[err.code] || `CODE_${err.code}` : undefined,
        };
      },

      requestBrowserPositionOnce(options, attemptLabel) {
        return new Promise((resolve, reject) => {
          console.log("[store-locator][geo] requesting navigator.geolocation", {
            attempt: attemptLabel,
            supported: Boolean(navigator.geolocation),
            secureContext: window.isSecureContext,
            protocol: window.location?.protocol,
            options,
          });

          if (!navigator.geolocation) {
            reject(new Error("geolocation unsupported"));
            return;
          }

          navigator.geolocation.getCurrentPosition(
            (pos) => {
              const coords = pos.coords;
              console.log("[store-locator][geo] browser position received", {
                attempt: attemptLabel,
                latitude: coords.latitude,
                longitude: coords.longitude,
                accuracyMeters: coords.accuracy,
                altitude: coords.altitude,
                heading: coords.heading,
                speed: coords.speed,
                timestamp: pos.timestamp,
              });
              resolve(coords);
            },
            (err) => {
              console.warn("[store-locator][geo] browser position failed", {
                attempt: attemptLabel,
                ...this.formatGeoError(err),
              });
              reject(err);
            },
            options
          );
        });
      },

      /**
       * Prefer a cached/network fix first, then retry with high accuracy on timeout.
       */
      async getBrowserPosition() {
        const attempts = [
          {
            label: "1/cached-or-network",
            options: { enableHighAccuracy: false, timeout: 15000, maximumAge: 600000 },
          },
          {
            label: "2/high-accuracy",
            options: { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 },
          },
        ];

        let lastError = null;
        for (const attempt of attempts) {
          try {
            return await this.requestBrowserPositionOnce(attempt.options, attempt.label);
          } catch (err) {
            lastError = err;
            const code = err?.code;
            // Don't retry if the user denied permission
            if (code === 1) break;
            console.log("[store-locator][geo] retrying with next strategy…", {
              failedAttempt: attempt.label,
              error: this.formatGeoError(err),
            });
          }
        }

        throw lastError || new Error("geolocation failed");
      },

      findClosestMarketHandle(lat, lng) {
        const ranked = Object.values(this.marketsByHandle || {})
          .map((market) => {
            if (market.lat == null || market.lng == null) {
              return {
                handle: market.handle,
                name: market.name,
                lat: market.lat,
                lng: market.lng,
                distanceKm: null,
                skipped: "missing lat/lng",
              };
            }
            const distanceKm = this.haversineKm(lat, lng, market.lat, market.lng);
            return {
              handle: market.handle,
              name: market.name,
              lat: market.lat,
              lng: market.lng,
              distanceKm,
              skipped: null,
            };
          })
          .sort((a, b) => {
            if (a.distanceKm == null) return 1;
            if (b.distanceKm == null) return -1;
            return a.distanceKm - b.distanceKm;
          });

        console.log("[store-locator][geo] distance ranking vs user position", {
          user: { lat, lng },
          markets: ranked,
        });

        const best = ranked.find((m) => m.distanceKm != null);
        return best
          ? { handle: best.handle, name: best.name, distanceKm: best.distanceKm, ranked }
          : null;
      },

      hasSavedStoreSelection() {
        try {
          const saved = JSON.parse(localStorage.getItem("currentStoreSelected") || "null");
          return Boolean(saved?.selectedStore);
        } catch (_) {
          return false;
        }
      },

      /**
       * Ask for browser location and auto-select the closest market store.
       * @param {{ force?: boolean, quiet?: boolean }} [opts]
       *   force — user clicked "Use my location" (always try)
       *   quiet — session auto-prompt (no error UI on deny)
       */
      async detectNearbyStore({ force = false, quiet = false } = {}) {
        const source = force ? "button:use-my-location" : "auto:first-open";
        console.log("[store-locator][geo] detectNearbyStore start", {
          source,
          force,
          quiet,
          geoLoading: this.geoLoading,
          filterMarketHandle: this.filterMarketHandle,
          hasSavedStore: this.hasSavedStoreSelection(),
        });

        if (this.geoLoading) {
          console.log("[store-locator][geo] skipped — already loading");
          return false;
        }

        if (!force) {
          try {
            if (sessionStorage.getItem(GEO_SESSION_KEY)) {
              console.log("[store-locator][geo] skipped — already prompted this session", {
                key: GEO_SESSION_KEY,
              });
              return false;
            }
          } catch (_) {}
          if (this.hasSavedStoreSelection()) {
            console.log("[store-locator][geo] skipped — saved store already exists");
            return false;
          }
          if (this.filterMarketHandle) {
            console.log("[store-locator][geo] skipped — filter already active", {
              filterMarketHandle: this.filterMarketHandle,
            });
            return false;
          }
          try {
            sessionStorage.setItem(GEO_SESSION_KEY, "1");
          } catch (_) {}
        }

        this.geoLoading = true;
        this.geoError = false;
        this.postalError = false;
        this.postalFallback = false;

        try {
          await this.loadPostalData();
          const marketHandles = Object.keys(this.marketsByHandle || {});
          console.log("[store-locator][geo] markets loaded for distance check", {
            count: marketHandles.length,
            handles: marketHandles,
            marketsByHandle: this.marketsByHandle,
            stores: this.stores,
          });

          const coords = await this.getBrowserPosition();
          const closest = this.findClosestMarketHandle(coords.latitude, coords.longitude);
          if (!closest?.handle) {
            console.warn("[store-locator][geo] no closest market — missing coords on markets?", {
              user: { lat: coords.latitude, lng: coords.longitude },
              marketsByHandle: this.marketsByHandle,
            });
            if (!quiet) this.geoError = true;
            return false;
          }

          console.log("[store-locator][geo] selecting closest market/store", {
            source,
            user: { lat: coords.latitude, lng: coords.longitude, accuracyMeters: coords.accuracy },
            closest: {
              handle: closest.handle,
              name: closest.name,
              distanceKm: Number(closest.distanceKm?.toFixed?.(2) ?? closest.distanceKm),
            },
          });
          this.filterMarketHandle = closest.handle;
          const selected = this.selectClosestStore(closest.handle);
          console.log("[store-locator][geo] selectClosestStore result", {
            ok: selected,
            selectedStore: this.selectedStore,
            currentSelected: this.currentSelected,
            closestBlockId: this.closestBlockId,
            visibleStoreIds: this.visibleStoreIds,
          });
          if (force && selected && this.selectedStore) {
            this.geoResultStoreName = this.selectedStore;
            this.geoResultOpen = true;
            console.log("[store-locator][geo] showing result dialog", {
              store: this.geoResultStoreName,
              distanceKm: Number(closest.distanceKm?.toFixed?.(2) ?? closest.distanceKm),
            });
          }
          try {
            sessionStorage.setItem(GEO_SESSION_KEY, "1");
          } catch (_) {}
          return true;
        } catch (err) {
          console.warn("[store-locator][geo] detectNearbyStore failed", {
            source,
            error: this.formatGeoError(err),
          });
          if (!quiet) this.geoError = true;
          return false;
        } finally {
          this.geoLoading = false;
          console.log("[store-locator][geo] detectNearbyStore end", {
            source,
            geoError: this.geoError,
            filterMarketHandle: this.filterMarketHandle,
            selectedStore: this.selectedStore,
          });
        }
      },

      /** Once per session on first locator open with no saved store. */
      async trySuggestFromGeolocation() {
        await this.detectNearbyStore({ force: false, quiet: true });
      },

      closeGeoResult() {
        this.geoResultOpen = false;
      },

      openStoreLocatorPopup() {
        this.show = true;
        try {
          Alpine.store("xMaximizePopup")?.handleOpen?.();
          Alpine.store("xMaximizeDrawer").activeDrawerElement = window.Maximize?.isShowPopupOverlay;
        } catch (_) {
          /* stores may be missing in some previews */
        }
        console.log("[store-locator] openStoreLocatorPopup show=true");
        this.trySuggestFromGeolocation();
      },

      closeStoreLocatorPopup() {
        this.geoResultOpen = false;
        if (this.currentSelected === false) {
          localStorage.removeItem("currentStoreSelected");
          Alpine.store("xStoreMap").currentStoreSelected = "";
          Alpine.store("xStoreMap").currentPostal = "";
          document.dispatchEvent(new CustomEvent("maximize:store-changed", { detail: { store: "" } }));
        }
        this.show = false;
        try {
          Alpine.store("xMaximizePopup")?.handleClose?.();
        } catch (_) {}
      },

      toggleSelected(el, currentSelected) {
        this.currentSelected = this.currentSelected == currentSelected ? false : currentSelected;
        this.selectedStore = this.currentSelected ? el.dataset.storeName : "";
      },

      async setSelectedStore() {
        if (!this.currentSelected) return;
        const postal = this.pendingPostal || "";
        const storeName = this.selectedStore;
        Alpine.store("xStoreMap").currentStoreSelected = storeName;
        Alpine.store("xStoreMap").currentPostal = postal
          ? this.formatPostalDisplay(postal)
          : Alpine.store("xStoreMap").currentPostal || "";
        localStorage.setItem(
          "currentStoreSelected",
          JSON.stringify({
            selectedStore: storeName,
            currentSelected: this.currentSelected,
            postal:
              postal || JSON.parse(localStorage.getItem("currentStoreSelected") || "null")?.postal || "",
          })
        );
        document.dispatchEvent(
          new CustomEvent("maximize:store-changed", { detail: { store: storeName } })
        );
        this.closeStoreLocatorPopup();

        // Sync cart attribute first so transforms apply, then full page refresh
        try {
          if (window.Maximize?.activeLocation?.ensure) {
            await window.Maximize.activeLocation.ensure(storeName);
          }
        } catch (err) {
          console.error("[store-locator] active_location sync before refresh failed", err);
        }
        window.location.reload();
      },

      isItemPartiallyVisible(el) {
        const itemEl = el.closest(".store-locator__content__item") || el;
        const listItemsEl =
          window.innerWidth >= MIN_DEVICE_WIDTH.tablet
            ? el.closest(".store-locator__content")
            : el.closest(".store-locator__wrapper");
        if (!itemEl || !listItemsEl) return;
        const itemRect = itemEl.getBoundingClientRect();
        const listItemsRect = listItemsEl.getBoundingClientRect();
        return (
          itemRect.bottom > listItemsRect.top &&
          itemRect.top < listItemsRect.bottom &&
          itemRect.right > listItemsRect.left &&
          itemRect.left < listItemsRect.right
        );
      },

      toggleActive(id) {
        this.active = this.active === id ? null : id;
      },
    }));
  }

  function ensureStoreLocatorBound(root) {
    if (!root || !window.Alpine) return null;
    try {
      const existing = Alpine.$data(root);
      if (existing && typeof existing.openStoreLocatorPopup === "function") return existing;
    } catch (_) {}

    registerStoreLocator();
    try {
      // Re-bind if Alpine started before xStoreLocator was registered.
      Alpine.destroyTree?.(root);
      Alpine.initTree(root);
      return Alpine.$data(root);
    } catch (err) {
      console.error("[store-locator] ensureStoreLocatorBound failed", err);
      return null;
    }
  }

  function openA2ZStoreLocatorPopup() {
    const root = getStoreLocatorRoot();
    console.log("[store-locator] open attempt", {
      hasRoot: !!root,
      hasAlpine: !!window.Alpine,
      xDataAttr: root?.getAttribute("x-data"),
      sectionId: root?.dataset?.sectionId,
    });

    if (!root) {
      console.error("[store-locator] popup container not found in DOM");
      return false;
    }

    const data = ensureStoreLocatorBound(root);
    if (data && typeof data.openStoreLocatorPopup === "function") {
      data.openStoreLocatorPopup();
      console.log("[store-locator] opened via Alpine component");
      return true;
    }

    // Last resort: force visible without Alpine reactivity
    root.removeAttribute("x-cloak");
    root.style.setProperty("display", "flex", "important");
    root.style.pointerEvents = "auto";
    const dialog = document.getElementById("StoreLocatorPopup__Container");
    if (dialog) {
      dialog.removeAttribute("x-cloak");
      dialog.style.setProperty("display", "flex", "important");
    }
    console.warn("[store-locator] forced CSS open (Alpine bind missing)");
    return true;
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-open-store-locator]");
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openA2ZStoreLocatorPopup();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const trigger = event.target.closest?.("[data-open-store-locator]");
    if (!trigger) return;
    event.preventDefault();
    openA2ZStoreLocatorPopup();
  });

  document.addEventListener("alpine:init", registerStoreLocator);

  // If this script loads after Alpine already started, register + rebind.
  if (window.Alpine) {
    registerStoreLocator();
    const root = getStoreLocatorRoot();
    if (root) ensureStoreLocatorBound(root);
  }

  document.addEventListener("alpine:initialized", () => {
    registerStoreLocator();
    const root = getStoreLocatorRoot();
    if (root) ensureStoreLocatorBound(root);
  });
}
